import React from 'react'
import Button from '@material-ui/core/Button';
import { NavLink } from 'react-router-dom';
const Puz27 = () => {
    return (
        <div>
            <NavLink to='/category/Puzzels/Puzzel28'>
<Button variant="contained" color="primary" style={{float:'right', margin:'25px',marginRight:'80px'}}>Next page -&gt; </Button>
</NavLink> &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
<NavLink to='/category/Puzzels/Puzzel26'>
<Button variant="contained" color="primary" style={{float:'left', margin:'25px',marginLeft:'70px'}}>&lt;-   Previous page </Button>
</NavLink>
<article class="container">
    <h1 class="title">Hourglasses Puzzle</h1>
   
    <div class="text">
        <p><strong><u>Puzzle</u>:</strong> Given two hourglass of 4 minutes and 7 minutes, the task is to measure 9
            minutes.<br/>
            </p>
            <div class="containers">
        <p><strong><u>Solution</u>:</strong></p>
        <ol>
            <li><strong>At 0 minutes: </strong>Start both hourglasses at the same time.<br/>
            </li>
            <li><strong>At 4 minutes:</strong> 4 minutes hourglass runs out and flip it. 7 minutes hourglass is left
                with 3 minutes.<br/>
                </li>
            <li><strong>At 7 minutes:</strong> 4 minutes hourglass is left with 1 minute. 7 minutes hourglass runs out
                and flip it.<br/>
                </li>
            <li><strong>At 8 minutes:</strong> 4 minutes hourglass runs out and 7 is filled with 6 minutes and 1 minute
                on the other side. Flip it as the sand is left with 1 minute.<br/>
                </li>
            <li><strong>At 9 minutes:</strong> 7 minutes hourglass becomes empty from above side.<br/>
            </li>
        </ol>
        <p>Hence we measured 9 minutes.</p>
       
          </div>
    </div>
</article>
        </div>
    )
}

export default Puz27
